import { Map } from 'immutable';

export const DropdownOptions = Map({
    default: [
        { value: 'true', text: 'Yes' },
        { value: 'false', text: 'No' },
    ],
    adviceArea: [
        { value: 391, text: 'Insurance & Protection' },
        { value: 396, text: 'Auto Enrolment' },
        { value: 397, text: 'Investments & Savings' },
        { value: 392, text: 'Mortgages' },
        { value: 393, text: 'Pension & Retirement' },
        { value: 557, text: 'Occupational Pension Transfers' },
        { value: 394, text: 'Equity Release' },
        { value: 558, text: 'Inheritance Planning' },
        { value: 395, text: 'Annuities' },
        { value: 635, text: 'Pension Transfer - Specialist' },
    ],
    adviceTime: [
        { value: 'now', text: 'Now / ASAP' },
        { value: '1-6 months', text: 'Between 1-6 months from now' },
        { value: 'more than 6 months', text: 'More than 6 months from now' },
        { value: 'just interested', text: "I'm just interested in whether I can get a mortgage" },
    ],
});
